import { getIsBlankVerboten } from '@/model/productType/getIsBlankVerboten';
import { getProductType } from '@/redux/draft/getters/getProductType';
import { StoreState } from '@/redux/types';

export const selectIsBlankVerbotenProductType = (state: StoreState) =>
  getIsBlankVerboten(getProductType(state));
